import React, { Component } from 'react';

export default class PopupInfo extends Component {
    constructor() {
        super();
        this.state = {}
    }
    render() {
        return (

            <div className="info">
                <div className="close"></div>
                <div className="left">
                    <div className="name">
                        {this.props.name} , {this.props.city}
                    </div>
                    <div className="country">
                        ארץ המוצא : {this.props.country}
                    </div>
                    <div className="text">
                        {this.props.text}
                    </div>
                </div>
                <div className="right">
                    <div className={`image-${this.props.id}`}>
                    </div>
                </div>

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/Popup/PopupInfo.jsx